module.exports = __webpack_public_path__ + "img/top-bg2.1c9954ef.png";